import { Formik, FormikHelpers, isString } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Modal } from "rsuite";
import { Loader } from "../../components";
import { GetCurrency } from "../../helpers/getCurrency";
import { purchasedPackage, startpaymentsecurity } from "../../redux/auth/saga";
import { PackageDto } from "../../redux/homepage/type";
import { languageSelector } from "../../redux/languages";
import { getPaymentTypes } from "../../redux/system/saga";
import { PaymentTypeDto } from "../../redux/system/type";
import * as Yup from "yup";
import Step1 from "./step1";
import Step2 from "./step2";
import { Buffer } from "buffer";
import { getLocalization } from "../../redux/localization";
import { Loader as LoaderRs } from "rsuite";
import { Alert } from "reactstrap";
import { clientAppUrl } from "../../redux/base/types/url";
import Get3DFailMessage from "./errorMessage";
import { useNavigate } from "react-router";

export type formProps = {
  IdentityNumber: string;
  Name: string;
  Surname: string;
  isAccept: boolean;
  CountryId: string;
  CityId: string;
  DistrictId: string;
  SubdistrictId: string;
  LocationTitle: string;
  NeighbourhoodId: string;
  PackageId: string;
  CreateCardDto: {
    CardNumber: string;
    Month: number;
    Years: number;
    Cvc: number;
    FullName: string;
  };
  PaymentTypeId: number;
  Email: string;
  IsMonth: boolean;
  AddressDetail: string;
  isSecurity: boolean;
};

const PaymentModal = ({
  packageData,
  show,
  setShow,
  IsMonth,
}: {
  IsMonth: boolean;
  packageData: PackageDto;
  show: boolean;
  setShow: (show: boolean) => void;
}) => {
  const language = useSelector(languageSelector);
  const dispatch = useDispatch();
  const [paymentTypes, setPaymentTypes] = useState<PaymentTypeDto[]>([]);
  const [step, setStep] = useState<number>(1);
  const [loader, setLoader] = useState<boolean>(false);
  const [html, setHtml] = useState<string>();
  const [error, setError] = useState<string>();
  const [payerror, setPayError] = useState<string>();
  const history = useNavigate();
  const [success, setSuccess] = useState<string>();
  const [refresh, setRefresh] = useState<string>();
  const [secure, setSecure] = useState<string>();
  const t = useSelector(getLocalization);
  useEffect(() => {
    if (show) {
      window.addEventListener("message", async (e) => {
        if (e.data && isString(e.data) && e.data.includes("token=")) {
          !(success && success.includes("token=")) &&
            (await setSuccess(e.data));
          setHtml("");
          return window.removeEventListener("message", () => {
            //@ts-ignore
            console.log("removequery");
          });
        } else if (e.data && isString(e.data) && e.data.includes("error=")) {
          let errormsg = e.data.replace("error=", "");
          setError(errormsg);
          setHtml("");
          return window.removeEventListener("message", () => {
            //@ts-ignore
            console.log("removequery");
          });
        }
      });
      return window.removeEventListener("message", () => {
        //@ts-ignore
        console.log("removequery");
      });
    }
  }, [show]);

  useEffect(() => {
    if (success && success.includes("token=")) {
      let token = success.replace("token=", "");
      history("/" + language.Code.split("-")[0] + "/payment-success/" + token);
    }
  }, [success]);
  useEffect(() => {
    if (!show) {
      setHtml("");
      setSecure("");
      setPayError("");
      setError("");
      setSuccess("");
    }
    show &&
      dispatch(
        getPaymentTypes({
          payload: {
            onSuccess: (message, payload) => {
              setPaymentTypes(payload);
            },
            onError: () => {},
          },
        })
      );
  }, [dispatch, show]);

  useEffect(() => {}, [html]);
  const payWith3dsecurity = (
    values: any,
    formikHelpers: FormikHelpers<any>
  ) => {
    setLoader(true);
    dispatch(
      startpaymentsecurity({
        payload: {
          onSuccess: (message, payload) => {
            setSecure("");
            setLoader(false);
            setHtml(payload.threeDSHtmlContent);
          },
          onError: (message, error) => {
            setSecure("");
            setLoader(false);
            setError(message);
          },
        },
        body: {
          ...values,
          CreateCardDto: values.PaymentTypeId === 1 ? values.CreateCardDto : "",
        },
      })
    );
  };
  const pay = (values: any, formikHelpers: FormikHelpers<any>) => {
    setLoader(true);
    setPayError("");
    dispatch(
      purchasedPackage({
        payload: {
          onSuccess: (message, payload) => {
            setLoader(false);
            setShow(false);
            setStep(1);
            formikHelpers.resetForm();
            history(
              "/" + language.Code.split("-")[0] + "/payment-success/" + payload
            );
            setSuccess("success");
          },
          onError: (message, error) => {
            setLoader(false);
            if (message === "redirect3dsecure") {
              setSecure(t.getString("redirect3dsecure"));
              payWith3dsecurity(values, formikHelpers);
            } else {
              if (
                error &&
                error.Errors &&
                Array.isArray(error.Errors) &&
                error.Errors.some((x: any) => x.Code === "DuplicateUserName")
              ) {
                setPayError(t.getString("ErrorsDuplicateUserName"));
              } else {
                setPayError(message);
              }
            }
          },
        },
        body: {
          ...values,
          CreateCardDto: values.PaymentTypeId === 1 ? values.CreateCardDto : "",
        },
      })
    );
  };

  return (
    <>
      <Modal open={show} size={"md"}>
        <Modal.Header
          onClose={() => {
            setShow(false);
            setStep(1);
          }}
        >
          <Modal.Title className="text-center fw-bold font-size-24">
            {loader && <Loader />}
            {packageData.Name}
            <br />
            <span className=" font-size-18"> {t.getString("Price")} : </span>
            <span className="fw-400 font-size-18">
              {IsMonth
                ? GetCurrency(
                    packageData.CampaignPriceMonthly,
                    packageData.CurrencyCode,
                    language.Code
                  )
                : GetCurrency(
                    packageData.CampaignPriceYearly,
                    packageData.CurrencyCode,
                    language.Code
                  )}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {success && (
            <div className="d-flex flex-column justify-content-center align-items-center">
              <div>
                <i className=" bx bx-check-circle text-success font-size-32" />
              </div>
              <div className="text-center fw-bold font-size-18">
                {t.getString("3dsuccessmessage")}
                <br />
                {t.getString("3dredirectingmessage")}
              </div>
            </div>
          )}
          {error && (
            <div>
              <Alert color="danger">
                <Get3DFailMessage status={error} />
              </Alert>
            </div>
          )}
          {payerror && (
            <div>
              <Alert color="danger">{payerror} </Alert>
            </div>
          )}
          <Formik
            initialValues={{
              IdentityNumber: "",
              Name: "",
              isAccept: false,
              Surname: "",
              PackageId: packageData.Id,
              CreateCardDto: {
                CardNumber: "",
                Month: "",
                Years: "2024",
                Cvc: "",
                FullName: "",
              },
              PaymentTypeId: 1,
              Email: "",
              isSecurity: true,
              IsMonth: IsMonth,
            }}
            validationSchema={Yup.object().shape({
              isAccept: Yup.boolean().oneOf(
                [true],
                t.getString("Please accept Terms Conditions")
              ),
              Email: Yup.string()
                .required(t.getString("This field is required"))
                .email(t.getString("Email is not valid")),
              IdentityNumber: Yup.string()
                .required(t.getString("This field is required"))
                .test(
                  "len",
                  t.getString("Must be min 5 char"),
                  //@ts-ignore
                  (val) => val?.toString().length >= 5
                ),
              Name: Yup.string().required(
                t.getString("This field is required")
              ),
              Surname: Yup.string().required(
                t.getString("This field is required")
              ),

              CreateCardDto: Yup.object().when(["PaymentTypeId"], {
                is: (type: any) => type === 1,
                then: Yup.object().shape({
                  CardNumber: Yup.string().required(
                    t.getString("This field is required")
                  ),
                  FullName: Yup.string().required(
                    t.getString("This field is required")
                  ),
                  Month: Yup.string().required(
                    t.getString("This field is required")
                  ),
                  Years: Yup.string().required(
                    t.getString("This field is required")
                  ),
                  Cvc: Yup.string().required(
                    t.getString("This field is required")
                  ),
                }),
              }),
            })}
            onSubmit={(values, formikHelpers) => {
              setError("");
              return pay(values, formikHelpers);
            }}
          >
            {({ handleSubmit, values, validateForm }) => {
              return (
                <>
                  {secure && (
                    <>
                      <LoaderRs content={secure} center />
                    </>
                  )}
                  {!secure && !html && !success && (
                    <>
                      <div className="w-100 px-3 py-2">
                        {step === 1 && <Step1 />}
                      </div>
                      <div className="w-100 px-3 py-2">
                        {step === 2 && <Step2 paymentTypes={paymentTypes} />}
                      </div>
                      {step === 1 && (
                        <div className="d-flex justify-content-end">
                          <button
                            className="primaryButton mt-2"
                            style={{ width: "200px" }}
                            onClick={() => {
                              validateForm().then((error) => {
                                if (
                                  step === 1 &&
                                  !error.IdentityNumber &&
                                  !error.Name &&
                                  !error.Surname &&
                                  !error.PackageId &&
                                  !error.Email
                                ) {
                                  setStep(2);
                                }
                              });
                            }}
                          >
                            {t.getString("Next")}
                          </button>
                        </div>
                      )}
                      {step === 2 && (
                        <div className="d-flex justify-content-between">
                          <button
                            className="primaryButton mt-2"
                            style={{ width: "200px" }}
                            onClick={() => setStep(1)}
                          >
                            {t.getString("Previous")}
                          </button>
                          <button
                            type="submit"
                            className="primaryButton mt-2"
                            style={{ width: "200px" }}
                            onClick={() => handleSubmit()}
                          >
                            {t.getString("Complete Purchased")}
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </>
              );
            }}
          </Formik>
          <iframe
            title="iframe"
            id={"iframe"}
            srcDoc={html}
            style={{ width: "100%", height: html ? 700 : 0 }}
          ></iframe>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default PaymentModal;
